import styles from "../TeamLogo.module.scss";

export function CollegeBaseball({
  fill,
  secondaryfill,
  width = "100%",
  height = "100%",
  accessibilityLabel = "",
}: {
  fill?: string;
  secondaryfill?: string;
  width?: string | number;
  height?: string | number;
  accessibilityLabel?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      aria-label={accessibilityLabel}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.26114 9.80675C7.32747 12.2149 7.30535 13.6174 7.12838 14.7818L6.98242 15.8668L7.95121 16.5152L14.3712 18.4195L19.338 17.6385C19.6787 17.5503 20.625 16.9862 21.7398 16.5946C22.1777 15.6683 21.9919 11.5004 21.7 9.42303C21.4664 7.76115 19.8155 6.82523 19.0192 6.56501C18.0195 6.32243 15.6086 5.80817 13.963 5.69173C12.3174 5.57529 10.8797 6.04016 10.3665 6.28715C9.17214 6.78995 7.64597 6.63117 7.26114 9.80675Z"
        fill={fill}
      />
      <path
        d="M7.26114 9.80675C7.32747 12.2149 7.30535 13.6174 7.12838 14.7818L6.98242 15.8668L7.95121 16.5152L14.3712 18.4195L19.338 17.6385C19.6787 17.5503 20.625 16.9862 21.7398 16.5946C22.1777 15.6683 21.9919 11.5004 21.7 9.42303C21.4664 7.76115 19.8155 6.82523 19.0192 6.56501C18.0195 6.32243 15.6086 5.80817 13.963 5.69173C12.3174 5.57529 10.8797 6.04016 10.3665 6.28715C9.17214 6.78995 7.64597 6.63117 7.26114 9.80675Z"
        fill="url(#paint0_linear_7827_2069)"
        fillOpacity="0.2"
      />
      <path
        d="M7.18659 14.6732C7.49172 15.6337 10.2819 16.7744 13.7909 17.3228C16.6441 17.7687 19.165 17.6965 20.3222 17.2124C18.3516 18.3404 13.9359 19.8084 8.49326 19.443C2.52915 19.0425 1.724 17.3741 2.06699 16.5899L7.15154 14.6675L7.18659 14.6732Z"
        fill={secondaryfill}
      />
      <path
        d="M7.18659 14.6732C7.49172 15.6337 10.2819 16.7744 13.7909 17.3228C16.6441 17.7687 19.165 17.6965 20.3222 17.2124C18.3516 18.3404 13.9359 19.8084 8.49326 19.443C2.52915 19.0425 1.724 17.3741 2.06699 16.5899L7.15154 14.6675L7.18659 14.6732Z"
        fill="url(#paint1_linear_7827_2069)"
        fillOpacity="0.2"
      />
      <path
        d="M14.583 5.88403C16.2627 6.53452 19.4828 9.75907 18.9256 17.4534C19.2943 17.5928 20.933 7.41733 14.583 5.88403Z"
        fill="black"
        fillOpacity="0.04"
      />
      <path
        d="M14.4404 5.69482C12.107 6.28067 7.63367 9.1848 8.40768 16.1145C7.89545 16.2401 5.61901 7.07575 14.4404 5.69482Z"
        fill="black"
        fillOpacity="0.04"
      />
      <ellipse
        cx="13.8634"
        cy="8.61672"
        rx="0.404882"
        ry="0.317163"
        fill={secondaryfill}
      />
      <ellipse
        cx="0.174684"
        cy="0.317478"
        rx="0.174684"
        ry="0.317478"
        transform="matrix(0.817457 -0.575989 0.578279 0.815839 18.9062 8.42505)"
        fill={secondaryfill}
      />
      <ellipse
        cx="0.100595"
        cy="0.317478"
        rx="0.100595"
        ry="0.317478"
        transform="matrix(-0.817457 -0.575989 -0.578279 0.815839 8.9707 7.96704)"
        fill={secondaryfill}
      />
      <ellipse
        cx="14.4174"
        cy="5.78782"
        rx="0.602471"
        ry="0.287821"
        fill={secondaryfill}
      />
      <defs>
        <linearGradient
          id="paint0_linear_7827_2069"
          x1="12.1266"
          y1="10.5052"
          x2="11.6434"
          y2="16.1272"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7827_2069"
          x1="2"
          y1="17.0837"
          x2="20.3222"
          y2="17.0837"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
